import styled from 'styled-components';

const Row = styled.div`
    --row-spacer: 1rem;
    display: flex;
    flex-wrap: wrap;
    margin-right: calc(0px - var(--row-spacer));
    margin-left: calc(0px - var(--row-spacer));
`;

export {Row};
